import { createContext, useCallback, useContext, useState } from "react";

/**
 * Lightweight pub/sub for "the booking dataset has changed".
 * Pages that fetch bookings depend on `bookingsVersion` in their effects.
 * Sophie calls bumpBookings() whenever a tool mutation succeeds.
 */
const RefreshContext = createContext(null);

export function RefreshProvider({ children }) {
  const [bookingsVersion, setBookingsVersion] = useState(0);
  const bumpBookings = useCallback(() => setBookingsVersion((v) => v + 1), []);
  return (
    <RefreshContext.Provider value={{ bookingsVersion, bumpBookings }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  const ctx = useContext(RefreshContext);
  if (!ctx) throw new Error("useRefresh must be used within RefreshProvider");
  return ctx;
}
